module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-2.fba492ad.jpg";